module.exports = __webpack_public_path__ + "static/media/Google__G__Logo.f6ce5696.svg";